import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LayoutService } from './layout.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  dialogRef!: MatDialogRef<any>;
  constructor(
    private layoutService: LayoutService,
    private breakpointObserver: BreakpointObserver
  ) {}

  getDialogConfig() {
    // Default configuration with dynamic width and custom panel class for styling
    let dialogConfig = {
      width: 'calc(100% - 20px)', 
      maxWidth: 'calc(100% - 20px)', 
      autoFocus: false,
      disableClose: true,
      panelClass: 'custom-dialog-container',
    };

    // Adjust width for larger screens if needed, keeping 10px margin
    if (this.breakpointObserver.isMatched('(min-width: 600px)')) {
      dialogConfig.width = 'calc(600px - 20px)';
      dialogConfig.maxWidth = 'calc(600px - 20px)';
    }

    return dialogConfig;
  }
  closeDialog() {
    this.dialogRef?.close();
  }
}
